import app from '../../forum/app';
import Component from '../../common/Component';
import Button from '../../common/components/Button';
import SessionDropdown from './SessionDropdown';
import SelectDropdown from '../../common/components/SelectDropdown';
import NotificationsDropdown from './NotificationsDropdown';
import ItemList from '../../common/utils/ItemList';
import listItems from '../../common/helpers/listItems';
import GlobalSearch from './GlobalSearch';
import ThemeSwitcher from './ThemeSwitcher';

/**
 * The `HeaderSecondary` component displays secondary header controls, such as
 * the search box and the user menu. On the default skin, these are shown on the
 * right side of the header.
 */
export default class HeaderSecondary extends Component {
  view() {
    return m("ul", {
      className: "Header-controls"
    }, listItems(this.items().toArray()));
  }

  /**
   * Build an item list for the controls.
   *
   * @return {ItemList}
   */
  items() {
    const items = new ItemList();
    items.add('search', m(GlobalSearch, {
      state: app.search.state
    }), 30);
    if (app.allowUserColorScheme && app.forum.attribute('showThemeSelector')) {
      items.add('themeSwitcher', m(ThemeSwitcher, null), 12);
    }
    if (app.forum.attribute('showLanguageSelector') && Object.keys(app.data.locales).length > 1) {
      const locales = [];
      for (const locale in app.data.locales) {
        locales.push(m(Button, {
          active: app.data.locale === locale,
          icon: app.data.locale === locale ? 'fas fa-check' : true,
          onclick: () => this.changeLocale(locale)
        }, app.data.locales[locale]));
      }
      items.add('locale', m(SelectDropdown, {
        className: "LocaleDropdown",
        buttonClassName: "Button Button--link",
        icon: "fas fa-globe",
        accessibleToggleLabel: app.translator.trans('core.forum.header.locale_dropdown_accessible_label')
      }, locales), 20);
    }
    if (app.session.user) {
      items.add('notifications', m(NotificationsDropdown, {
        state: app.notifications
      }), 10);
      items.add('session', m(SessionDropdown, null), 0);
    } else {
      if (app.forum.attribute('allowSignUp')) {
        items.add('signUp', m(Button, {
          className: "Button Button--link",
          onclick: () => app.modal.show(() => import(/* webpackChunkName: 'forum/components/SignUpModal', webpackMode: 'lazy-once' */ './SignUpModal'))
        }, app.translator.trans('core.forum.header.sign_up_link')), 10);
      }
      items.add('logIn', m(Button, {
        className: "Button Button--link",
        onclick: () => app.modal.show(() => import(/* webpackChunkName: 'forum/components/LogInModal', webpackMode: 'lazy-once' */ './LogInModal'))
      }, app.translator.trans('core.forum.header.log_in_link')), 0);
    }
    return items;
  }

  /**
   * Switch the forum to the given locale.
   *
   * @param {string} locale
   */
  changeLocale(locale) {
    if (app.session.user) {
      app.session.user.savePreferences({
        locale
      }).then(() => window.location.reload());
    } else {
      document.cookie = `locale=${locale}; path=/; expires=Tue, 19 Jan 2038 03:14:07 GMT`;
      window.location.reload();
    }
  }
}
flarum.reg.add('core', 'forum/components/HeaderSecondary', HeaderSecondary);flarum.reg.addChunkModule('559', '9509', 'core', 'forum/components/SignUpModal');